// This pack's primary purpose is to import application.scss.

// JS Rails routes
/*eslint-disable */

//suppress all warnings between comments
import $ from 'jquery'
window.$ = jQuery

/*eslint-enable */

import * as Routes from 'routes.js.erb'
window.Routes = Routes

// OAuth
import 'sessions/oauth'
import 'user/login_welcome_tooltip'
import 'bootstrap/js/src/modal'

import 'site-auth.scss'
import 'bootstrap/js/src/alert'
import 'theme/plugins'
import 'form/toggle_password'
import 'form/password_tooltip'
import 'form/clear-form-after-entry'
import 'utils/banners'
